module.exports = __webpack_public_path__ + "static/img/4areaA_7.9eb97cd.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/ワンダーエージェント_イラスト/4areaA_7.png
// module id = 903
// module chunks = 1